import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0697ab0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light" }
const _hoisted_2 = { class: "row w-100 justify-content-center" }
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-6 bg-white py-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-2" }, " Paramétrage de la pharmacie "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " Merci de renseigner les informations de votre pharmacie pour pouvoir utiliser l’application. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfosPharmacie = _resolveComponent("InfosPharmacie")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode(_component_InfosPharmacie, { onSaved: _ctx.onSaved }, null, 8, ["onSaved"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}